import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import introduction from "./components/introduction";
import inputSignal from "./components/input-signal";
import outerMiddle from "./components/outer-middle";
import frequency from "./components/frequency";
import innerHair from "./components/inner-hair";
import psychoacoustic from "./components/psychoacoustic";

const principle: Slide = {
  title: "Hearing Model of Sottek (HMS)",
  description:
    "Hearing models aim to replicate different aspects of the human auditory system processing through algorithms.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Introduction" },
            { name: "Input Signal" },
            { name: "Outer and Middle Ear Filtering" },
            { name: "Frequency to place transform (Basillar Membrane)" },
            { name: "Inner Hair Cells Firing" },
            { name: "Psychoacoustic Parameter Calcualtion(e.g. Loudness)" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], [], [], []],
      components: [introduction, inputSignal, outerMiddle, frequency, innerHair, psychoacoustic],
    },
  },
};

export default principle;
